<div class="input-group">
    <div class="input-group-prepend">
    </div>
      <ngb-datepicker [(ngModel)]="date"></ngb-datepicker>
  </div>